import React, { useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import {
  WidgetsTitledCards,
  WidgetsUserReservationInfos,
  WidgetsProductsInfo,
} from "../../../components/_widgets/WidgetsTitledCards";
import { WidgetsChartCard } from "../../../components/_widgets/WidgetsChartCard";
import LineChart from "../../../components/_charts/LineChart";
import { WidgetsIconCards, WidgetsArrowNumber } from "../../../components/_widgets/WidgetsIconCards";
import { useAuth } from "../../../context/ContextApi";
import EmptyListContent from "../Dashboard/EmptyListContent";
import { ListComments, ListCommentsItem } from "../../../components/_widgets/WidgetsListComments";
import api from "../../../config/api";
import Moment from "moment-timezone";
import { extendMoment } from "moment-range";
import { parseISO, formatDistance } from "date-fns";
import pt from "date-fns/locale/pt";
import EmptyContentLittle from "../../../components/EmptyContent/EmptyContentLittle";
import { getCategory } from "../../../config/utils";

const moment = extendMoment(Moment);

require("dotenv").config();

function Dashboard() {
  const [chartList, setChartList] = useState([]);
  const { userToken, userEstablishment } = useAuth();
  const [canceled, setCanceled] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [mostPopular, setMostPopular] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [lastYearReserves, setLastYearReserves] = useState(0);
  const [lastYearSales, setLastYearSales] = useState(0);
  const [sales, setSales] = useState(0);
  const [reserves, setReserves] = useState(0);
  const [comments, setComments] = useState([]);
  const [totalComments, setTotalComments] = useState(0);
  const [qtLimitItemComments, setQtLimitItemComments] = useState(6);
  const [pageComment, setPageComment] = useState(1);

  const lastYearFilter = (object) => {
    let formatDate = object[0].split("/");
    let month = parseInt(formatDate.splice(1, 1)) + 1;
    formatDate.splice(0, 0, month);
    formatDate = formatDate.join("/");
    const date = moment(new Date(formatDate)).format("YYYY");
    return moment(date).isBefore(moment().subtract(1, "years"));
  };

  const getClientGroupReservation = async () => {
    await api
      // TODO: Fix when client reservation group implemented
      .get(`/clientGroupReservation/${userEstablishment}`, {
        headers: { Authorization: `Bearer ${userToken}` },
      })
      .then((resp) => {
        if (resp.data.data) {
          setChartList(resp.data.data);
          setLastYearReserves(() =>
            resp.data.data
              ?.filter((object) => {
                return lastYearFilter(object);
              })
              .reduce((acc, item) => item[1].reservas + acc, 0)
          );
          setLastYearSales(() =>
            parseFloat(
              resp.data.data
                ?.filter((object) => {
                  return lastYearFilter(object);
                })
                .reduce((acc, item) => item[1].total + acc, 0)
            ).toFixed(2)
          );
          setSales(() => resp.data.data?.reduce((acc, item) => item[1].total + acc, 0));
          setReserves(() => resp.data.data?.reduce((acc, item) => item[1].reservas + acc, 0));
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getComments(pageComment, qtLimitItemComments);
  }, [pageComment, qtLimitItemComments]);
  // useEffect(() => {console.log(chartList?.reduce((acc,item) => item[1]?.totalVendas + acc, 0))},[chartList]);

  const getComments = async (page, limit) => {
    let response = await api.get(`/comment/${userEstablishment}?paginate=true&page=${page}&limit=${limit}`);
    setComments(response.data.docs);
  };

  const setLimitListComments = (value) => {
    setQtLimitItemComments(value);
    setPageComment(1);
    getComments(1, value);
  };
  const changePageComments = (event) => {
    setPageComment(event.target.id);
    getComments(event.target.id, qtLimitItemComments);
  };
  const prevButtonComments = () => {
    if (pageComment !== 1) {
      setPageComment(pageComment - 1);
      getComments(pageComment - 1, qtLimitItemComments);
    }
  };
  const nextButtonComments = () => {
    let qtPages = Math.ceil(totalComments / qtLimitItemComments);
    if (pageComment.toString() !== qtPages.toString()) {
      setPageComment(pageComment + 1);
      getComments(pageComment + 1, qtLimitItemComments);
    }
  };

  const getMostPopular = async (establishment) => {
    const response = await api.get(`/dashboard/${establishment}`, {
      headers: { Authorization: `Bearer ${userToken}` },
    });
    setMostPopular(response.data.popularProducts);
  };

  const getSchedules = async (token, id) => {
    try {
      const config = { headers: { Authorization: "Bearer " + token } };
      await api

        .get(`/establishmentReservations?establishment=${id}`, config)
        .then(function (response) {
          // console.log(response.data);
          let filteredPending = response.data.filter(function (item) {
            return item.status.includes("Pendente");
          });
          setSchedule(filteredPending);

          let filteredCanceled = response.data.filter(function (item) {
            return item.status.includes("Cancelada");
          });
          setCanceled(filteredCanceled);
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(async () => {
    getClientGroupReservation();
    getSchedules(userToken, userEstablishment);
    getMostPopular(userEstablishment);
    await getCategory();
  }, [userToken]);

  return (
    <>
      <Layout defaultMenu={0} title={"Dashboard"} link={""}>
        <div className="dashboard container-fluid px-lg-1">
          <div className="d-flex flex-column flex-lg-row">
            <WidgetsTitledCards title={"Reservas recentes"}>
              {isLoading ? (
                <>
                  {/* <WidgetLoadingSkeleton />
                  <WidgetLoadingSkeleton />
                  <WidgetLoadingSkeleton />
                  <WidgetLoadingSkeleton /> */}
                </>
              ) : schedule.length === 0 ? (
                <EmptyContentLittle description={"Não existem reservas recentes"} />
              ) : (
                schedule.map((item, index) => (
                  <WidgetsUserReservationInfos
                    key={item._id}
                    title={item.user.name}
                    description={item.time}
                    avatar={item.user.avatar}
                    linkText={"Ver detalhes"}
                    link={`/reservas/${item._id}`}
                  />
                ))
              )}
            </WidgetsTitledCards>
            <WidgetsTitledCards className={"my-2 my-lg-0 me-lg-3 ms-lg-3"} title={"Reservas canceladas"}>
              {isLoading ? (
                <>
                  {/* <WidgetLoadingSkeleton />
                  <WidgetLoadingSkeleton />
                  <WidgetLoadingSkeleton />
                  <WidgetLoadingSkeleton /> */}
                </>
              ) : canceled.length === 0 ? (
                <EmptyContentLittle description={"Não existem reservas canceladas"} className={""} />
              ) : (
                canceled.map((item, index) => (
                  <WidgetsUserReservationInfos
                    key={item._id}
                    title={item.user.name}
                    description={item.time}
                    avatar={item.user.avatar}
                    linkText={"Ver detalhes"}
                    link={`/reservas/${item._id}`}
                  />
                ))
              )}
            </WidgetsTitledCards>
            <WidgetsTitledCards title={"Produtos populares"} className={" widgets-dashboard"}>
              {mostPopular.length ? (
                <>
                  {mostPopular.map((item, index) => (
                    <WidgetsProductsInfo
                      key={item.product.name}
                      title={item.product.name}
                      descriptionLeft={"Preço: "}
                      leftValue={parseFloat(item.product.price).toFixed(2).replace(".", ",")}
                      leftValueColor={"text-cl-forest-green"}
                      descriptionRight="reservas"
                      rightValue={item.times}
                    />
                  ))}
                </>
              ) : (
                <EmptyContentLittle description={"Não existem reservas recentes"} />
              )}
            </WidgetsTitledCards>
          </div>
          <div className="d-flex flex-column flex-lg-row mt-3 mb-3">
            <div className="col-lg-8 me-lg-2 pe-1">
              <WidgetsChartCard
                title={"Análise de vendas"}
                firstLegend="Reservas"
                classNameFirstLegend="bg-cl-azure-2"
                secondLegend="Vendas"
                classNameSecondLegend="bg-cl-heliotrope"
                sizeLG={"8"}
              >
                <LineChart chartList={chartList} />
              </WidgetsChartCard>
            </div>
            <div className="col-lg ">
              <div className="d-flex flex-column ps-1">
                <WidgetsIconCards sizeLG={""} className={"mt-2 mt-lg-0"} title={"TOTAL DE VENDAS PELO APP"}>
                  <WidgetsArrowNumber
                    value={sales}
                    isCurrency={true}
                    isFloat={true}
                    statics={((sales / lastYearSales - 1) * 100).toFixed(2)}
                    descriptionValue={lastYearSales}
                    description={`(Ano passado `}
                  />
                </WidgetsIconCards>
                <WidgetsIconCards
                  sizeLG={""}
                  className={"mt-2 mt-lg-3"}
                  typeIcon="calendar"
                  title={"TOTAL DE RESERVAS"}
                >
                  <WidgetsArrowNumber
                    value={reserves}
                    descriptionValue={lastYearReserves}
                    statics={((reserves / lastYearReserves - 1) * 100).toFixed(2)}
                    description={`(Ano passado `}
                  />
                </WidgetsIconCards>
              </div>
            </div>
          </div>
          <div className="col-lg ">
            <div className="d-flex flex-column mb-4">
              <WidgetsChartCard title={"Últimos comentarios"}>
                <ListComments
                  onChange={(e) => setLimitListComments(e.target.value)}
                  limit={qtLimitItemComments}
                  totalItem={totalComments}
                  prevButton={() => prevButtonComments()}
                  nextButton={() => nextButtonComments()}
                  page={pageComment}
                  changePage={(e) => changePageComments(e)}
                >
                  {comments?.length ? (
                    <>
                      {comments.map((item, index) => (
                        <>
                          <ListCommentsItem
                            key={item._id}
                            establishment
                            avatar={item.user.avatar}
                            time={formatDistance(parseISO(item.createdAt), new Date(), {
                              addSuffix: true,
                              locale: pt,
                            })}
                            pageComment={pageComment}
                            qtLimitItemComments={qtLimitItemComments}
                            getComments={getComments}
                            userName={item.user.name}
                            stars={item.rate}
                            comment={item.comment}
                            reply={item.reply}
                            index={index}
                            id={item._id}
                            storeName={item.establishment.storeName}
                          />
                        </>
                      ))}
                    </>
                  ) : (
                    <div className="col-12 d-flex justify-content-center">
                      <EmptyListContent className={"col-lg-6"} description={"Não existem comentários"} />
                    </div>
                  )}
                </ListComments>
              </WidgetsChartCard>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Dashboard;
